const MOBILE_APP_REDIRECTS = {
  SETTINGS: {
    EDIT_PASSWORD_URL_HASH: '#alterar-senha',
    EDIT_PROFILE_URL_HASH: '#alterar-perfil',
  },
  FEEDBACK: '#fale-com-promobit',
};

export default MOBILE_APP_REDIRECTS;
